export const LOADING_EXCEL_UPLOAD = "LOADING_EXCEL_UPLOAD";
export const EXCEL_UPLOAD_FAIL = "EXCEL_UPLOAD_FAIL";
export const EXCEL_UPLOAD_PROBLEMS = "EXCEL_UPLOAD_PROBLEMS";
